import { Fragment } from 'react'

export const FormioSkeleton = ({ rows = 3 }: { rows?: number }) => {
  return (
    <div className="w-full animate-pulse space-y-6 rounded-xl bg-white">
      {Array.from({ length: rows }).map((_, i) => (
        <Fragment key={i}>
          <div className="h-4 w-2/3 rounded bg-grey-200" />
          <div className="h-12 w-full rounded-lg bg-grey-200" />
        </Fragment>
      ))}
      <div className="h-12 w-full rounded-full bg-grey-200" />
    </div>
  )
}
